import { useToolEntryField } from '#plugin-chat/hooks/useToolEntryField.ts';
import type { ToolDisplaySpec } from '#plugin-chat/lib/tool/message-formatters.ts';

/**
 * Type-erased {@link ToolDisplaySpec} — the shape attached to a tool entry
 * after generic args have been forgotten across the model-context boundary.
 * Use this at every consumer that reads `display` off a registered tool;
 * the per-tool generic args are not recoverable at lookup time.
 */
export type AnyToolDisplaySpec = ToolDisplaySpec<Record<string, unknown>, unknown>;

/**
 * Reads the registered tool's `display` spec from the assistant-ui model
 * context. The `<Tool>` component attaches the spec onto each tool entry
 * so the tool-display chrome can synthesise its slots without a per-tool
 * render component.
 *
 * Returns `undefined` when the tool isn't registered or doesn't declare a
 * `display` spec — the chrome falls back to its default behaviour in that
 * case.
 */
export function useToolDisplaySpec(toolName: string | undefined): AnyToolDisplaySpec | undefined {
  return useToolEntryField<AnyToolDisplaySpec>(toolName, 'display');
}
